module.exports = __webpack_public_path__ + "static/media/menu-novidades-versao.b9ed748b.png";